import 'bootstrap/dist/css/bootstrap.min.css';
import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import AuthService from '../services/authService';
import '../styles/Login.css';

const Login = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState(''); 
    const [password, setPassword] = useState(''); 
    const [logging, setLogging] = useState(false); 

    const log = async () => {
        setLogging(true); 
        try {
            const response = await AuthService.connection(username, password); 
            if (response.success) {
                navigate('/'); 
            } else {
                alert(response.error); 
            }
        } catch (error) {
            alert('Une erreur s\'est produite.'); 
        }
        setLogging(false); 
    };

    return (
        <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
            <div className="card p-4" style={{ maxWidth: '400px', width: '100%', height: '370px' }}>
                <h1 className="card-title text-center mb-4">Se connecter</h1>
                <label htmlFor="username">Nom d'utilisateur</label>
                <input
                    type="text"
                    className="form-control mb-3"
                    onChange={(event) => setUsername(event.target.value)}
                    value={username}
                    placeholder="Nom d'utilisateur"
                    id="username"
                />
                <label htmlFor="password">Mot de passe</label>
                <input
                    type="password"
                    className="form-control mb-3"
                    onChange={(event) => setPassword(event.target.value)}
                    value={password}
                    placeholder="Mot de passe"
                    id="password"
                />
                <button className="btn btn-primary btn-block" onClick={log} disabled={logging}>
                    {logging ? 'Connexion...' : 'Se connecter'}
                </button>
                <br />
                <p style={{ color: 'blue', textDecoration: 'underline' }}>
                    <Link to="/sign">Créez un compte</Link>
                </p>
            </div>
        </div>
    );
};

export default Login;
